import styled from 'styled-components';

export const ThresholdFields = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 360px;
`;

// The toggles are a separate group, so they sit clearly below the thresholds
export const ToggleSection = styled.div`
    margin-top: 32px;
`;

// The results of the last check, below both buttons and the run outcome
export const RunResults = styled.div`
    margin-top: 24px;
`;

export const RunFinding = styled.div`
    margin-top: 16px;
`;
